import { Component } from '@verndale/core';
import Swiper, { Navigation, Scrollbar } from 'swiper';
import { breakpoints } from '../helpers/constants';

Swiper.use([Navigation, Scrollbar]);

class TabbedCarousel extends Component {
  setupDefaults() {
    this.isExpEditor = this.el.dataset.isExpEditor === 'true';
    this.dom = {
      sliders: [...this.el.querySelectorAll('.tabbed-carousel__tab-content')],
      cards: this.el.querySelectorAll('.cta-description-card'),
      sliderWrapper: this.el.querySelector('.swiper-wrapper'),
      tabsButtons: this.el.querySelectorAll('.tabbed-carousel__tabs-info'),
      tabsContainer: this.el.querySelector('.tabbed-carousel__tabs')
    };
    this.currentTab = 0;
    this.initializeTabs();
    //initializing active slider on load
    this.dom.sliders.forEach(slider => {
      const scroll = slider.querySelector('.swiper-scrollbar');
      const nextBtn = slider.querySelector('.swiper-button-next');
      const prevBtn = slider.querySelector('.swiper-button-prev');

      if (slider.classList.contains('active')) {
        this.initSlider(slider, nextBtn, prevBtn, scroll);
      }
    });
  }

  initializeTabs() {
    if (this.dom.sliders.length > 0) {
      this.renderTabs();
      this.dom.sliders[0].classList.add('active');
      this.dom.sliders[0].setAttribute('tabindex', 0);
      this.el.classList.add('initialized');
    }
  }

  addListeners() {
    const { cards } = this.dom;
    cards.forEach(card =>
      card.addEventListener('mouseover', ::this.onHoverCard)
    );
    cards.forEach(card =>
      card.addEventListener('mouseleave', ::this.onLeaveCard)
    );
    window.addEventListener('resize',  () => {
      this.dom.sliders.forEach(slider => this.hideControls(slider))
    })
    this.dom.tabs.forEach((tab, index) => {
      // Click event on tab
      tab.addEventListener('click', e => this.handleTabsClick(e, index));
      // Keydown event on tab
      tab.addEventListener('keydown', e => this.handleTabsKeydown(e));
    })
  }

  initSlider(slider, nextBtn, prevBtn, scroll) {
    const sliderOptions = new Swiper(slider, {
      slidesPerView: 1.3,
      spaceBetween: 22,
      scrollbar: {
        el: scroll,
        draggable: true
      },
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn
      },
      breakpoints: {
        [breakpoints.tablet]: {
          slidesPerView: 3.3,
          spaceBetween: 20
        },
        [breakpoints.tabletLandscape]: {
          slidesPerView: 4.3,
          spaceBetween: 24
        },
        [breakpoints.laptop]: {
          slidesPerView: 4,
          spaceBetween: 32
        },
        [breakpoints.desktop]: {
          slidesPerView: 4,
          spaceBetween: 40
        },
        [breakpoints.wide]: {
          slidesPerView: 4,
          spaceBetween: 48
        },
        [breakpoints.fullHd]: {
          slidesPerView: 4,
          spaceBetween: 68
        }
      }
    });
    this.hideControls(slider);
  }

  changeControlsDisplay(controls, display) {
    controls.style.display = display;
  }

  hideControls(slider) {
    const controls = slider.querySelector('.controls-btns');
    const cards = slider.querySelectorAll('.swiper-slide');

    if (window.innerWidth >= breakpoints.laptop && cards.length <= 4) {
      return this.changeControlsDisplay(controls, 'none')
    } else if (window.innerWidth >= breakpoints.tablet && cards.length <= 3) {
      return this.changeControlsDisplay(controls, 'none')
    } else if (window.innerWidth < breakpoints.tablet && cards.length < 2) {
      return this.changeControlsDisplay(controls, 'none')
    }
    return this.changeControlsDisplay(controls, 'flex');
  }

  onHoverCard(e) {
    const { cards } = this.dom;
    cards.forEach(
      card => !card.contains(e.target) && card.classList.add('light-opacity')
    );
  }

  onLeaveCard(e) {
    const { cards } = this.dom;
    cards.forEach(
      card => !card.contains(e.target) && card.classList.remove('light-opacity')
    );
  }

  changeSelectedTab(tabIndex) {
    this.currentTab = tabIndex;
    this.hideControls(this.dom.sliders[tabIndex]);
    const tabs = this.el.querySelectorAll(
      '.tabbed-carousel__tabs button[role="tab"]'
    );
    const tabsContent = this.el.querySelectorAll(
      '.tabbed-carousel__tab-content[role="tabpanel"]'
    );
    const currentTabContent = tabsContent[tabIndex];
    const currentTab = tabs[tabIndex];

    // Reset tabsContent styles and accessibility attributes
    tabsContent.forEach((tabContent, index) => {
      tabContent.setAttribute('tabindex', -1);
      tabContent.classList.remove('active');
    });
    // Update currentTabContent styles and accessibility attributes
    currentTabContent.setAttribute('tabindex', 0);
    currentTabContent.classList.add('active');
    // Reset tabs styles and accessibility attributes
    tabs.forEach(tab => {
      tab.setAttribute('aria-selected', false);
      tab.setAttribute('tabindex', -1);
      tab.classList.remove('active');
    });
    // Update currentTab styles and accessibility attributes
    currentTab.setAttribute('aria-selected', true);
    currentTab.setAttribute('tabindex', 0);
    currentTab.classList.add('active');
  }

  handleTabsClick(e, index) {
    this.changeSelectedTab(index);
    //initializing active slider
    this.dom.sliders.forEach(slider => {
      if (slider.classList.contains('active')) {
        const scroll = slider.querySelector('.swiper-scrollbar');
        const nextBtn = slider.querySelector('.swiper-button-next');
        const prevBtn = slider.querySelector('.swiper-button-prev');
        this.initSlider(slider, nextBtn, prevBtn, scroll);
      }
    });
  }

  handleTabsKeydown(e) {
    const keyMapper = { ArrowLeft: -1, ArrowRight: 1 };
    const tabs = this.el.querySelectorAll(
      '.tabbed-carousel__tabs button[role="tab"]'
    );
    // Return if theres no action for a key
    if (!keyMapper[e.key]) return;
    const nextTabIndex = keyMapper[e.key];
    const lastTabIndex = tabs.length - 1;
    // Handle navigation from 0 index to last index
    if (this.currentTab + nextTabIndex === -1) {
      this.changeSelectedTab(lastTabIndex);
      // Handle navigation from last index to 0 index
    } else if (this.currentTab + nextTabIndex > lastTabIndex) {
      this.changeSelectedTab(0);
      // Handle regular navigation
    } else {
      this.changeSelectedTab(this.currentTab + nextTabIndex);
    }
    //initializing active slider
    if (e.key) {
      this.dom.sliders.forEach(slider => {
        if (slider.classList.contains('active')) {
          const scroll = slider.querySelector('.swiper-scrollbar');
          const nextBtn = slider.querySelector('.swiper-button-next');
          const prevBtn = slider.querySelector('.swiper-button-prev');

          this.initSlider(slider, nextBtn, prevBtn, scroll);
        }
      });
    }
  }

  renderTabs() {
    // Generate tabs
    this.dom.tabsContainer.innerHTML = this.dom.sliders
      .filter(slider => {
        const hasCards = slider.querySelectorAll('.swiper-slide').length > 0;
        if (!hasCards && !this.isExpEditor) {
          slider.closest('.tabbed-carousel__tab-content').remove();
          this.dom.sliders = [...this.el.querySelectorAll('.tabbed-carousel__tab-content')];
        }
        return this.isExpEditor ? true : hasCards;
      })
      .map((tabContent, index) => {
        const tabId = tabContent.getAttribute('aria-labelledby');
        const tabContentId = tabContent.getAttribute('id');
        const tabLabel = tabContent.dataset.tabLabel;
        return `
        <button
          class='tabbed-carousel__tabs-info ${!index ? 'active' : ''}'
          role='tab'
          tabindex='${!index ? 0 : -1}'
          aria-selected='${(!index)}'
          aria-controls='${tabContentId}'
          id='${tabId}'
        >
          ${tabLabel}
        </button>
      `;
      }).join('');
    // Set tabs reference
    this.dom.tabs = [...this.el.querySelectorAll('.tabbed-carousel__tabs-info[role="tab"]')];
  }
}

export default TabbedCarousel;
